import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieHandler } from 'src/shared/classes/cookie.class';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(): boolean {

    const token = CookieHandler.getToken();

    if (token) {
      this.router.navigate(['/dashboards/analytics']);
      return false;
    }

    return true;
  }
}
